import { useEffect } from 'react'
import { APP_NAME } from '@/lib/constants'

/**
 * The tab's title while the caller is mounted: "Calls · RingOut". When it goes,
 * the title goes back to plain "RingOut", so the next page never inherits one
 * that isn't its own (the console's "Overview" on the sign-in page, say). Use it
 * once per page tree -- in the layout -- since a parent's effect runs after its
 * child's and would win.
 */
export function useDocumentTitle(...parts: (string | null | undefined)[]) {
  const title = [...parts.filter(Boolean), APP_NAME].join(' · ')
  useEffect(() => {
    document.title = title
    return () => {
      document.title = APP_NAME
    }
  }, [title])
}
